import useQuery from "hooks/useQuery";
import { showErrorModal } from "utils";
import { getLinea } from "./api";
import { useEffect } from "react";
import queryString from "query-string";

const useGetLinea = (lineaId, accion) => {
  const { data, refetch } = useQuery({
    autoFetch: false,
    queryFn: getLinea,
    onError: (err) => showErrorModal({ err }),
  });

  const fetch = () => {
    const query = queryString.stringify({
      accion,
    });
    refetch(lineaId, query);
  }

  useEffect(() => {
    if (!lineaId) return;
    fetch();
  }, [lineaId]);

  return {
    linea: data?.data?.linea,
    fetchLinea: fetch,
  }
}

export default useGetLinea;